import * as yup from "yup";

import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IGenericResult from "../../../../interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import TextField from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceConcessionaria from "../../../../services/serviceConcessionaria";
import serviceInstalacao from "../../../../services/serviceInstalacao";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    data: {
        open: boolean;
        id: string;
        numeroInstalacao: string;
        tipoInstalacao: string;
        tipoClasseInstalacao: string;
        classeInstalacao: string;
        concessionariaID: string;
    };
    onClose?: any;
}

export default function DialogEdit({ open, data, onClose, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);

    const validationSchema = yup.object().shape({
        numeroInstalacao: yup.string().required(messages.requiredField).typeError(messages.requiredField),
        tipoClasseInstalacao: yup.string().required(messages.requiredField).typeError(messages.requiredField),
        classeInstalacao: yup.string().required(messages.requiredField).typeError(messages.requiredField),
        concessionariaID: yup.string().required(messages.requiredField).typeError(messages.requiredField),
        tipoInstalacao: yup.string().required(messages.requiredField).typeError(messages.requiredField),
    });

    const tipoInstalacaoOptions = [
        { label: "Usina", value: "Usina" },
        { label: "Cliente", value: "Cliente" },
    ];

    const tipoClasseInstalacao = [
        { label: "Comercial", value: "Comercial" },
        { label: "Residencial", value: "Residencial" },
        { label: "Rural", value: "Rural" },
        { label: "Poder Público", value: "Poder Público" },
    ];

    const classeInstalacaoOptions = [
        { label: "Monofásico", value: "Monofásico" },
        { label: "Bifásico", value: "Bifásico" },
        { label: "Trifásico", value: "Trifásico" },
    ];

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    useEffect(() => {
        setConcessionariaData();
    }, []);

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    const onSubmit = (values: any) => {
        setDisable(true);
        const updateValues = {
            ...values,
            instalacaoID: data.id,
        };

        serviceInstalacao
            .update(updateValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose(true);
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <DialogTitle>
                Editar
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        reset();
                        onClose(true);
                    }}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent dividers>
                    <Grid container columnSpacing={2}>
                        <Grid item md={6}>
                            <TextField
                                name="numeroInstalacao"
                                label="Instalação"
                                control={control}
                                error={errors}
                                disabled={true}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <AutoComplete
                                name="tipoInstalacao"
                                label="Tipo Instalação"
                                options={tipoInstalacaoOptions}
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        <Grid item md={6}>
                            <AutoComplete
                                name="tipoClasseInstalacao"
                                label="Classe Instalacao"
                                options={tipoClasseInstalacao}
                                control={control}
                                error={errors}
                            />
                        </Grid>

                        <Grid item md={6}>
                            <AutoComplete
                                name="classeInstalacao"
                                label="Classe"
                                options={classeInstalacaoOptions}
                                control={control}
                                error={errors}
                            />
                        </Grid>

                        <Grid item md={6}>
                            <AutoComplete
                                name="concessionariaID"
                                label="Concessionaria"
                                options={concessionariaDataOptions}
                                control={control}
                                error={errors}
                                disabled={true}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
